// Import model
import { FilterLeadNoteRequest } from '../models/FilterLeadNoteRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { LeadNoteCondition } from '../models/LeadNoteCondition';
import { LeadNoteFields } from '../models/LeadNoteFields';
import { LeadNoteIndexedFields } from '../models/LeadNoteIndexedFields';

// Import dependency serializers (for complex types)
import { LeadNoteConditionSerializer } from './LeadNoteConditionSerializer';
import { LeadNoteFieldsSerializer } from './LeadNoteFieldsSerializer';
import { LeadNoteIndexedFieldsSerializer } from './LeadNoteIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterLeadNoteRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterLeadNoteRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterLeadNoteRequest instance
   */
  static deserialize(json: string): FilterLeadNoteRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterLeadNoteRequest instance
   */
  static fromObject(obj: any): FilterLeadNoteRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterLeadNoteRequest');
    }


    const instance: FilterLeadNoteRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as LeadNoteIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as LeadNoteFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        LeadNoteConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterLeadNoteRequest instances
   */
  static deserializeArray(json: string): FilterLeadNoteRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterLeadNoteRequest instance to a JSON string
   */
  static serialize(instance: FilterLeadNoteRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterLeadNoteRequest instance to a plain object
   */
  static toObject(instance: FilterLeadNoteRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        LeadNoteConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterLeadNoteRequest instances to a JSON string
   */
  static serializeArray(instances: FilterLeadNoteRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
